import { render, staticRenderFns } from "./PhonesHeadline.vue?vue&type=template&id=71fa26b6&scoped=true"
import script from "./PhonesHeadline.vue?vue&type=script&lang=ts"
export * from "./PhonesHeadline.vue?vue&type=script&lang=ts"
import style0 from "./PhonesHeadline.vue?vue&type=style&index=0&id=71fa26b6&prod&lang=scss&scoped=true"
import style1 from "./PhonesHeadline.vue?vue&type=style&index=1&id=71fa26b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa26b6",
  null
  
)

export default component.exports